module.exports = __webpack_public_path__ + "static/media/61.3d33e535.png";